import { useState, useEffect } from 'react';
import { getStatusBarHeight, getArgFromUrl, isNumber, _T, ZoneType, lang } from '@dana/components';
import './index.css';
import { getZone, getUserById } from '../api';
import { UserInfo } from '../api/type';
import Card from './card';
import { langAtom } from '../store';
import { Input, Popup } from 'react-vant';
import { useAtom } from 'jotai';
import { resolveRechargeConfig } from './recharge-config';
import { normalizeLanguageCode, setManualLanguage } from '../lang/language';

const LANGUAGE_OPTIONS = [
  {
    code: 'en',
    label: 'English',
    icon: require('../asset/imgs/en.png'),
  },
  {
    code: 'ar',
    label: 'العربية',
    icon: require('../asset/imgs/ar.png'),
  },
  {
    code: 'tr',
    label: 'Türkçe',
    icon: require('../asset/imgs/tr.png'),
  },
  {
    code: 'es',
    label: 'Español',
    icon: require('../asset/imgs/es.png'),
  },
  {
    code: 'pt',
    label: 'Português',
    icon: require('../asset/imgs/pt.png'),
  },
  {
    code: 'ru',
    label: 'Русский',
    icon: require('../asset/imgs/ru.png'),
  },
  {
    code: 'uz',
    label: "O'zbekcha",
    icon: require('../asset/imgs/uz.png'),
  },
] as const;

const LANGUAGE_LABEL_MAP = LANGUAGE_OPTIONS.reduce<Record<string, string>>((acc, item) => {
  acc[item.code] = item.label;
  return acc;
}, {});

const Pages: React.FC<{}> = ({ }) => {
  const [h, setH] = useState(0);
  const [id, setId] = useState('');
  const [show, setShow] = useState(false);
  const [showZone, setShowZone] = useState(false);
  const [zoneData, setZoneData] = useState<ZoneType[]>([]);
  const [zone, setZone] = useState<ZoneType>();
  const [user, setUser] = useState<UserInfo>();
  const [visible, setVisible] = useState(false);
  // const [lan, setLan] = useState(navigator.language === 'en' ? 'English' : '')
  const [lan, setLan] = useAtom(langAtom);
  const fetchData = async () => {
    const height = await getStatusBarHeight();
    setH(height || 44);
  };

  function handleInputChange(value: string) {
    const maxLength = 10;
    const isN = isNumber(value);
    // if (!value) {
    //     setId('')
    //     return
    // }
    // if (!isN) {
    //     return
    // }
    // 去除前后的不可见字符（空格、控制字符、零宽字符等）
    const invisibleCharRegex =
      /[\s\u0000-\u001F\u007F-\u009F\u200B-\u200F\u202A-\u202E\u2060-\u2064\u206A-\u206F\uFEFF\uFFF9-\uFFFB]/g;
    const trimmedValue = value
      .replace(new RegExp(`^${invisibleCharRegex.source}+`), '')
      .replace(new RegExp(`${invisibleCharRegex.source}+$`), '');

    // 如果输入内容超过限制长度，截取前10个字符
    if (trimmedValue.length > maxLength) {
      setId(trimmedValue.slice(0, maxLength));
    } else {
      setId(trimmedValue);
    }
  }

  const getZoneData = async () => {
    const res = await getZone();
    if (!res) return;

    const filterData = ["SA","MA","JO","EG","IQ","YE","QA","TR","IN","RU","UZ","PH","TH","MY","BD","ID","NG","IN","BR","PK","ES","PT","KW","OM","US","DE","DZ","AE","IT","FR","NL","CA","NO","GB","TN","BE","AL","DK","BH","RO","CH","GR","PL","CY","HR","AZ","IE","FI","AT"]
    const data = res
      .filter((item: any) => filterData.includes(item.code))
      .sort((a: any, b: any) => filterData.indexOf(a.code) - filterData.indexOf(b.code));

    setZoneData(data);
    setZone(data[0]);
  };

  useEffect(() => {
    fetchData();
    getZoneData();
  }, []);

  const data = resolveRechargeConfig(getArgFromUrl('rechargeAgent'));

  function changeLan(newLangCode: string) {
    const langCode = normalizeLanguageCode(newLangCode) || 'en';
    setManualLanguage(langCode);

    // 更新jotai状态
    setLan(langCode);

    // 更新window对象
    (window as any).lan = langCode;

    // 更新Translator类的语言设置
    (lang as any).lang = langCode;

    setShow(false);
  }

  async function searchUser() {
    // setUser({
    //     uid: 1234,
    //     nickname: 'zezezee',
    //     avatar: 'https://danachat-other.s3.eu-central-1.amazonaws.com/banner/banner_man-default_62127d6f795a706c.png',
    //     country: '',
    //     sex: 1
    // })
    if (!id) return;
    const res = await getUserById(id);
    if (!res) return;
    setUser(res);
  }

  return (
    <div className="w-[375px] relative bg-white h-screen" style={{ paddingTop: `${h}px` }}>
      <Popup visible={visible} onClose={() => setVisible(false)}>
        <div className="w-[295px] bg-[#fff] rounded-[12px] flex justify-center items-center flex-col py-[24px]">
          <div
            className="text-center text-[18px] font-bold font-sans capitalize w-[240px] text-[#333]"
            dir="auto"
          >
            {_T('注释')}
          </div>
          <div
            className="text-black font-sans text-sm font-semibold leading-6 w-[240px] mt-[6px]"
            dir="auto"
          >
            {_T('*本页价格仅为产品价格。')}
          </div>
          <div
            className="text-black font-sans text-sm font-semibold leading-6 w-[240px] mt-[6px]"
            dir="auto"
          >
            {_T('*以下价格根据汇率波动，请以实际支付价格为准。')}
          </div>
          {/* <div className="text-black font-sans text-sm font-semibold leading-6 w-[240px] mt-[6px]" dir="auto">
                    {_T('*选择不同国家后，再选择金币数量，将跳转至不同的支付方式页面。')}
                </div>
                <div className="text-black font-sans text-sm font-semibold leading-6 w-[240px] mt-[6px]" dir="auto">
                    {_T('*客服WhatsApp:+447927814683')}
                </div> */}
          <div
            onClick={() => setVisible(false)}
            className="flex items-center justify-center gap-2.5 h-11 px-7 py-3.5 rounded-[74px] w-[247px] mt-[24px]
                    bg-gradient-to-r from-[#89ED8B] to-[#1AD4A8] flex-1 text-white fon-sans text-base font-bold capitalize"
            dir="auto"
          >
            {_T('确定')}
          </div>
        </div>
      </Popup>
      {show && (
        <>
          <div className="fixed inset-0 z-[99]" onClick={() => setShow(false)} />
          <div
            className="w-[128px] absolute py-[12px] z-[100] right-[10px] top-[80px]
                        bg-white rounded-[8px] pl-[9px] shadow-[0px_4px_4px_0px_rgba(0,0,0,0.15)] flex flex-col gap-[18px]"
          >
            {LANGUAGE_OPTIONS.map((item) => (
              <div
                key={item.code}
                className="flex justify-start items-center"
                onClick={() => changeLan(item.code)}
              >
                <div
                  className="w-[18px] h-[18px] bg-cover"
                  style={{
                    backgroundImage: `url(${item.icon})`,
                  }}
                ></div>
                <div className="ml-[6px]" dir="auto">
                  {item.label}
                </div>
              </div>
            ))}
          </div>
        </>
      )}
      {showZone && (
        <>
          <div className="fixed inset-0 z-[99]" onClick={() => setShowZone(false)} />
          <div
            className="w-[98px] max-h-[204px] overflow-scroll absolute pb-[12px] z-[100] shadow-[0px_4px_4px_0px_rgba(0,0,0,0.15)]
                        right-[20px] top-[240px] bg-white rounded-[8px] flex flex-col"
          >
            {zoneData.map((item, index) => (
              <div
                key={index}
                className="flex justify-start items-center mx-auto mt-[12px] relative"
                onClick={() => {
                  setZone(item);
                  setShowZone(false);
                }}
              >
                <div
                  className="w-[18px] h-[18px] bg-cover"
                  style={{
                    backgroundImage: `url(${item.imgUrl})`,
                  }}
                ></div>
                <div className="ml-[6px] text-black font-sans text-sm font-semibold leading-normal">
                  {item.code}
                </div>
                <div
                  className="absolute z-50 w-[74px] h-[1px] left-[-10px] bottom-[-5px]"
                  style={{
                    backgroundColor: 'rgba(242, 242, 242, 0.84)',
                  }}
                ></div>
              </div>
            ))}
          </div>
        </>
      )}
      <div
        className="w-[375px] h-[212px] bg-cover absolute top-0 left-0"
        style={{
          backgroundImage: `url(${require('../asset/imgs/bg.png')})`,
        }}
      ></div>
      <div className="relative flex justify-between items-center px-[12px]">
        <div className="flex justify-center items-center">
          <div
            className="bg-cover w-[43px] h-[43px]"
            style={{
              backgroundImage: `url(${require('../asset/imgs/icon.png')})`,
            }}
          ></div>
          <div
            className="bg-cover h-[23px] w-[91px] ml-[8px]"
            style={{
              backgroundImage: `url(${require('../asset/imgs/DANA.png')})`,
            }}
          ></div>
        </div>
        <div className="flex justify-center items-center" onClick={() => setShow(!show)}>
          <div
            className="bg-cover w-[18px] h-[18px]"
            style={{
              backgroundImage: `url(${require('../asset/imgs/earth.png')})`,
            }}
          ></div>
          <div className="text-white font-sans text-[14px] font-semibold leading-normal ml-[6px]">
            {LANGUAGE_LABEL_MAP[lan] || LANGUAGE_LABEL_MAP.en}
          </div>
          <div
            className="bg-cover w-[11px] h-[11px] ml-[3px]"
            style={{
              backgroundImage: `url(${require('../asset/imgs/bottom.png')})`,
            }}
          ></div>
        </div>
      </div>
      <div
        className="relative z-1 w-[359px] h-[140px] bg-cover mx-auto mt-[24px]"
        style={{
          backgroundImage: `url(${require('../asset/imgs/card.png')})`,
        }}
      >
        {user && (
          <div className="flex justify-between items-center pt-[13px]">
            <div className="flex justify-center items-center ml-[18px]">
              <div
                className="w-[48px] h-[48px] rounded-full bg-cover"
                style={{
                  backgroundImage: `url(${user.avatar || ''})`,
                }}
              ></div>
              <div className="flex flex-col justify-center items-start ml-[10px]">
                <div className="flex justify-center items-center">
                  <div className="text-white font-sans text-[14px] font-bold leading-[18px] capitalize truncate w-[140px]">
                    {user.nickname}
                  </div>
                  <div className="w-[20px] h-[21px]"></div>
                </div>
                <div className="text-[#EDEDED] font-sans text-[12px] font-semibold leading-normal capitalize">
                  {id || user.uid}
                </div>
              </div>
            </div>
            <div
              onClick={() => setUser(undefined)}
              className="w-[72px] h-[32px] bg-cover mr-[22px] mt-[7px]"
              style={{
                backgroundImage: `url(${require('../asset/imgs/btn.png')})`,
              }}
            ></div>
          </div>
        )}
        {!user && (
          <div className="flex justify-center items-center pt-[20px]">
            <div className="w-[231px] h-[41px]">
              <Input
                className="rounded-[12px] bg-[#207953] h-[41px] pl-[12px]"
                value={id}
                onChange={handleInputChange}
                placeholder={_T('请输入用户ID')}
              />
            </div>
            <div
              onClick={searchUser}
              className="rounded-[24px] bg-white w-[72px] h-[32px] ml-[12px] text-[#00755C]
                    font-sfprotext text-[12px] font-semibold leading-normal flex justify-center items-center"
              dir="auto"
            >
              {_T('确定')}
            </div>
          </div>
        )}
        <div className="flex flex-col justify-center items-end mt-[8px] mr-[18px]">
          <div className="text-[#2A2A2A] font-sfprotext text-[14px] font-semibold leading-normal">
            {_T('国家&地区')}
          </div>
          <div
            className="rounded-[8px] bg-[rgba(255,255,255,0.5)] w-[78px] h-[26px] mt-[6px] flex justify-center items-center"
            onClick={() => setShowZone(true)}
          >
            <div
              className="w-[20px] h-[21px] bg-cover"
              style={{
                backgroundImage: `url(${zone?.imgUrl || ''})`,
              }}
            ></div>
            <div className="text-[#0C0C0C] font-sans text-[12px] font-semibold leading-normal ml-[3px]">
              {zone?.code}
            </div>
            <div
              className="w-[11px] h-[11px] ml-[6px] bg-cover"
              style={{
                backgroundImage: `url(${require('../asset/imgs/bottom2.png')})`,
              }}
            ></div>
          </div>
        </div>
      </div>
      <div className="flex justify-between items-center mt-[24px] px-[12px] mb-[12px]">
        <div
          className="text-[#221F1F] font-sans text-[16px] font-bold leading-normal capitalize"
          dir="auto"
        >
          {_T('充值金额')}
        </div>
        <div
          className="w-[16px] h-[16px] bg-cover"
          style={{
            backgroundImage: `url(${require('../asset/imgs/q.png')})`,
          }}
          onClick={() => setVisible(true)}
        ></div>
      </div>
      <div className="flex justify-start flex-wrap items-center px-[12px]">
        {data.map((item, index) => (
          <Card
            country={zone?.code || ''}
            uid={String(user?.uid)}
            data={item}
            key={index}
            index={index}
            isShowUser={!!user}
          />
        ))}
      </div>
    </div>
  );
};

export default Pages;
